import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-surface" data-id="element-185">
      <div className="container mx-auto px-4" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-188">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-muted text-[16px]" data-id="element-189">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-190">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-base/60 rounded-3xl p-8 shadow-lg border border-surface flex flex-col h-full" data-id="element-191">
            <div className="mb-6" data-id="element-192">
              <p className="text-muted font-bold mb-2" data-id="element-193">OPCIÓN 1</p>
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-194">
                ☢️ MEGAPACK ENERGÍA NUCLEAR LISTO™
              </h3>
              <p className="text-neon font-bold" data-id="element-195">6 Tomos + 5 Bonos</p>
            </div>

            <div className="mb-8" data-id="element-196">
              <p className="text-muted/70 line-through text-lg mb-1" data-id="element-197">
                $65.000 ARS
              </p>
              <div className="flex items-end gap-2" data-id="element-198">
                <span className="text-5xl font-black text-white" data-id="element-199">$19.990</span>
                <span className="text-xl font-bold text-muted mb-1" data-id="element-200">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-201">
              {['TOMO 1: Fundamentos de la Energía Nuclear', 'TOMO 2: Física Nuclear y Radiactividad', 'TOMO 3: Reactores Nucleares y Producción de Energía', 'TOMO 4: Seguridad Nuclear y Protección Radiológica', 'TOMO 5: Aplicaciones de la Energía Nuclear', 'TOMO 6: Energía Nuclear en Argentina y el Mundo', 'BONO 1: Banco de Actividades y Ejercicios Nucleares', 'BONO 2: Casos de Estudio (Chernóbil, Fukushima, CAREM)', 'BONO 3: Infografías y Esquemas HD listos para proyectar', 'BONO 4: Evaluaciones y Trabajos Prácticos listos para imprimir', 'BONO 5: Guía Didáctica Completa para el Docente', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-202">
                  <Check className="w-5 h-5 text-neon shrink-0 mt-0.5" data-id="element-203" />
                  <span className="text-white" data-id="element-204">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53866948428094:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-205">
              <Button variant="secondary" size="lg" fullWidth withArrow data-id="element-206">
                QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-base rounded-3xl p-8 shadow-2xl border-2 border-exclusive flex flex-col h-full relative lg:scale-105 z-10" data-id="element-207">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-exclusive text-white px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-1.5 whitespace-nowrap shadow-lg" data-id="element-208">
              <Star className="w-4 h-4 fill-white" data-id="element-209" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-210">
              <p className="text-muted font-bold mb-2" data-id="element-211">OPCIÓN 2</p>
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-212">
                ☢️ MEGAPACK ENERGÍA NUCLEAR LISTO™ + UPSELL PREMIUM
              </h3>
              <p className="text-exclusive font-bold" data-id="element-213">
                6 Tomos + 5 Bonos + SMR, Inteligencia Artificial y Fusión
                Nuclear 2026
              </p>
            </div>

            <div className="mb-8" data-id="element-214">
              <p className="text-muted/70 line-through text-lg mb-1" data-id="element-215">
                $100.000 ARS
              </p>
              <div className="flex items-end gap-2" data-id="element-216">
                <span className="text-5xl font-black text-white" data-id="element-217">$27.990</span>
                <span className="text-xl font-bold text-muted mb-1" data-id="element-218">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-219">
              <li className="flex items-start gap-3" data-id="element-220">
                <Check className="w-5 h-5 text-exclusive shrink-0 mt-0.5" data-id="element-221" />
                <span className="text-white font-bold" data-id="element-222">
                  Todo lo del MegaPack Energía Nuclear Listo, MÁS:
                </span>
              </li>
              {['UPSELL PREMIUM: SMR, Inteligencia Artificial y Fusión Nuclear 2026'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-223">
                  <Check className="w-5 h-5 text-exclusive shrink-0 mt-0.5" data-id="element-224" />
                  <span className="text-exclusive font-bold" data-id="element-225">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53866948493630:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-226">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" data-id="element-227">
                QUIERO EL MEGAPACK + UPSELL PREMIUM
              </Button>
            </a>

            <p className="text-center text-xs text-muted mt-4" data-id="element-228">
              Podés pagar con tarjeta de crédito o débito, transferencia
              bancaria o Mercado Pago en pesos argentinos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}